import { createRoot } from 'react-dom/client';
import 'tailwindcss/tailwind.css';

import App from './App';

const container = document.createElement('div');

container.id = 'root';
document.body.appendChild(container);

const root = createRoot(container);
root.render(<App />);